import styled from 'styled-components'

import { color, spacing } from '../../themes'

export const Container = styled.ul`
  border-bottom: 1px solid ${color('gray.04')};
  width: 100%;
`

export const Item = styled.li`
  display: flex;
  flex-direction: column;
  border-top: 1px solid ${color('gray.04')};
  padding: ${spacing(4)} 0;
`

export const IconContainer = styled.div`
  color: ${color('gray.02')};

  svg {
    height: 16px;
    width: 16px;
    min-width: 16px;
  }
`
